"use client"

import { useState } from "react"
import Link from "next/link"
import { ArrowRight } from "lucide-react"

export function CountryTabs({ countryData }) {
  const [activeCountry, setActiveCountry] = useState("canada")

  const country = countryData.find((c) => c.slug === activeCountry)

  return (
    <div className="mt-6 space-y-4">
      {/* Tabs */}
      <div className="flex gap-1 border-b">
        {countryData.map((c) => (
          <button
            key={c.slug}
            onClick={() => setActiveCountry(c.slug)}
            className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors ${
              activeCountry === c.slug
                ? "border-b-2 border-primary text-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <span>{c.flag}</span>
            <span className="hidden sm:inline">{c.name}</span>
          </button>
        ))}
      </div>

      {/* Questions for active country */}
      {country && (
        <div className="space-y-3">
          <p className="text-xs text-muted-foreground">{country.desc}</p>
          <div className="space-y-2">
            {country.questions.map((q) => (
              <Link
                key={q.id}
                href={`/app?q=${q.id}`}
                className="group flex flex-col gap-2 rounded-lg border p-4 transition-colors hover:bg-accent/50"
              >
                <p className="text-sm leading-relaxed text-foreground">{q.q}</p>
                <span className="inline-flex items-center gap-1 text-[11px] font-medium text-primary opacity-0 transition-opacity group-hover:opacity-100">
                  Practice with AI interviewer <ArrowRight className="size-3" />
                </span>
              </Link>
            ))}
          </div>
          <Link
            href="/app"
            className="group flex items-center justify-center gap-2 rounded-lg border border-dashed p-3 text-sm font-medium text-muted-foreground transition-colors hover:border-primary/30 hover:text-foreground"
          >
            Practice more {country.flag} {country.name} questions in the app
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>
      )}
    </div>
  )
}
